var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWfFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0.7)",
    stroke: "#748b94",
    transform: "translate(-459 -367) translate(459 367)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8c9c8",
    strokeWidth: "0.2px",
    d: "M-7824.2-2049a.66.66 0 0 1-.7-.7.66.66 0 0 1 .7-.7h3.8v-3.8a.66.66 0 0 1 .7-.7.66.66 0 0 1 .7.7v4.5a.66.66 0 0 1-.7.7zm-8.1 0a.662.662 0 0 1-.7-.7v-4.5a.662.662 0 0 1 .7-.7.66.66 0 0 1 .7.7v3.8h3.8a.662.662 0 0 1 .7.7.661.661 0 0 1-.7.7zm11.9-8.8v-3.8h-3.8a.66.66 0 0 1-.7-.7.661.661 0 0 1 .7-.7h4.5a.661.661 0 0 1 .7.7v4.5a.662.662 0 0 1-.7.7.662.662 0 0 1-.7-.7zm-12.6 0v-4.5a.663.663 0 0 1 .7-.7h4.5a.662.662 0 0 1 .7.7.662.662 0 0 1-.7.7h-3.8v3.8a.662.662 0 0 1-.7.7.663.663 0 0 1-.7-.7z",
    transform: "translate(-459 -367) translate(8299 2437)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfFullscreen);
export default __webpack_public_path__ + "static/media/wf-fullscreen.d70ea0894e38d803db25114e1a745660.svg";
export { ForwardRef as ReactComponent };